import { render, staticRenderFns } from "./MatchB2C.vue?vue&type=template&id=1f63a282&scoped=true&"
import script from "./MatchB2C.vue?vue&type=script&lang=js&"
export * from "./MatchB2C.vue?vue&type=script&lang=js&"
import style0 from "./MatchB2C.vue?vue&type=style&index=0&id=1f63a282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f63a282",
  null
  
)

export default component.exports